import React, { useEffect, useState } from 'react';
import { CONFIG } from 'config/config';
import {
	AnalyticsWrapper,
	NavigationWrapper,
	PickerHOC,
	SessionWrapper,
	UiWrapper,
	UserWrapper,
} from '@coinscrap/webapp-core';
import Header from 'layout/components/Header/Header';
import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen';

export const AutoLanding = PickerHOC(
	{},
	LoadingScreen,
)(() => {
	const { useHeader, useLoading } = UiWrapper.use();
	const { sessionData, sessionStatus } = SessionWrapper.use();
	const { user, loadSessionUser } = UserWrapper.use();
	const { transports, pageView } = AnalyticsWrapper.use();
	const { navigateTo, params, routes: prevRoutes, getCurrentRoute } = NavigationWrapper.use();
	const [loading, setLoading] = useState('Accediendo');

	useHeader(<Header />, []);
	useLoading(loading, { loadingMessage: loading });
	useInitialScrollToTop();

	useEffect(() => {
		console.log('user', user);
		console.log('sessionData', sessionData);
		console.log('sessionStatus', sessionStatus);
		if (!sessionData || sessionStatus === 'NOT_CREATED') {
			CONFIG.routing.autolanding.reLogin(navigateTo);
		} else if (!user) {
			(async () => {
				await loadSessionUser();
			})();
		} else {
			const lastEngine = transports[transports?.length - 1 || 0]?.engine || '';
			// ESPERAMOS QUE SE HAYAN CARGADO TODOS LOS ANALYTICS
			if (user?.metadata?.analytics[lastEngine]) {
				(async () => {
					try {
						await pageView({
							date: new Date(),
							name: 'AutoLanding',
							route: getCurrentRoute(),
							params,
							lang: 'es',
							prevRoutes,
						});
						CONFIG.routing.autolanding.next(navigateTo);
						setLoading(undefined);
					} catch (error) {
						console.log('❌ error', error);
					}
				})();
			}
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sessionData, sessionStatus, user]);

	return <></>;
});
